<template>
    <i18n path="no-allocation-variants-with-active-status" class="text-center text-gray-500 font-light mb-2" tag="div">
        <template #active1>
            <Badge size="Small" variant="Green">{{ $t('active-1') }}</Badge>
        </template>
        <template #active2>
            <Badge size="Small" variant="Green">{{ $t('active-2') }}</Badge>
        </template>
    </i18n>
</template>

<script setup lang="ts">
import Badge from '../Badge/Badge.vue';
</script>
